var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotorcycle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8f8f8f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M240.607,376.125a2.151,2.151,0,0,0-2.182,2.105v4.263a2.183,2.183,0,0,0,4.364,0V378.23A2.151,2.151,0,0,0,240.607,376.125Z",
    transform: "translate(-231.661 -360.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M97.18,2.632h-4.2a3.93,3.93,0,0,0-7.418,0H81.416a1.075,1.075,0,0,0-1.091,1.053,1.075,1.075,0,0,0,1.091,1.053h4.2a3.657,3.657,0,0,0,1.691,2.105,6.94,6.94,0,0,0-5.127,6.579v5.526a1.785,1.785,0,0,0,1.8,1.737h1.473v-3a3.875,3.875,0,0,1,7.745,0v3H94.67a1.785,1.785,0,0,0,1.8-1.737V13.474a6.892,6.892,0,0,0-5.127-6.579,3.657,3.657,0,0,0,1.691-2.105h4.2a1.075,1.075,0,0,0,1.091-1.053A1.169,1.169,0,0,0,97.18,2.632ZM89.27,5.842a2.151,2.151,0,0,1-2.182-2.105,2.183,2.183,0,0,1,4.364,0A2.084,2.084,0,0,1,89.27,5.842Z",
    transform: "translate(-80.325)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.6ae0d240.svg";
export { ForwardRef as ReactComponent };